/*
 * @Author: renmanyi
 * @Date: 2021-12-08 16:17:37
 * @LastEditors: renmanyi
 * @LastEditTime: 2022-09-09 12:02:27
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
import axios from './axios';
import { random_string } from './function';
import { message } from 'antd'
class Upload {

 // 存储收费最新改造上传方法
  /**
   * @description:
   * @param blob:上传文件，
   * @param name：文件名字，
   * @param type: 文件类型 如 image/png  image/jpeg...
   * @param bizCode：业务code,
   * @param studentId:学员id,
   * @param returnType:progess 自己处理长传进度,
   * @return dataType:'url'默认返回上传链接，否则返回上传信息全部里面有resourceId
   */
   static newUploadBlobToOSS(data) {
    const { blob, name, type, bizCode, dir, dataType = 'url', studentId, returnType } = data;
    if (!bizCode) {
      return message.warning('请补充业务code');
    }
    const originType = type.split('/')[1] === 'mpeg' ? 'mp3' : type.split('/')[1];
    const oriResourceName =
      name.length > 50 ? name.substring(0, 40) + name.substring(name.length - 10, name.length) : name;
    let resourceName = random_string(16) + '.' + originType; //用文件名字加type拼接
    // 上传图片和视频
    let params = {
      resourceName,
      oriResourceName,
      bizCode,
      instId: window.userAdminInfo.instId 
    };
    if (studentId) {
      params.userType = 'STUDENT';
      params.userId = studentId;
    }
    if (bizCode === 'UPLOAD_REGISTER_STUDENT_FACE') {
      params['data'] = { studentId };
    }
    if (bizCode === 'UPLOAD_SEARCH_STUDENT_FACE') {
      params['data'] = { searchId:random_string(32) };
    }
    return axios.postJSON('mfs/anon/mfs/webTokenWithAccessUrl', params).then((res) => {
      const signInfo = res.result;
      const { url } = res.result;
      return this.uploadBlobToNewOSS(blob, name, dir, signInfo.signatureVO || signInfo).then(() => {
        return dataType === 'url' ? url : signInfo;
      });
    });
   }
  
  static uploadBlobToNewOSS(Blob, name, dir, signInfo) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      var fd = new FormData();
      fd.append('OSSAccessKeyId', signInfo.accessId);
      fd.append('policy', signInfo.policy);
      fd.append('callback', signInfo.callback);
      fd.append('Filename', name);
      fd.append('expire', signInfo.expire);
      fd.append('signature', signInfo.signature);
      fd.append('key', signInfo.key);
      fd.append('file', Blob);
      fd.append('success_action_status', 200);
      xhr.open('POST', signInfo.host.replace(/http:/, 'https:'), true);
      xhr.onload = () => {
        const result = JSON.parse(xhr.responseText);
        resolve(result.url, signInfo.resourceId);
      };
      xhr.send(fd);
    });
  }

}

export default Upload;